const API_URL = import.meta.env.VITE_API_URL || '';

function getCsrfToken(): string | null {
  const match = document.cookie.match(/(?:^|;\s*)veraid-csrf=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : null;
}

export async function api(path: string, options?: RequestInit): Promise<Response> {
  const url = `${API_URL}${path}`;
  const csrfToken = getCsrfToken();
  const headers: Record<string, string> = {
    ...(options?.headers as Record<string, string>),
  };

  if (!headers['Content-Type'] && options?.body) {
    headers['Content-Type'] = 'application/json';
  }

  if (csrfToken && options?.method && options.method !== 'GET') {
    headers['X-CSRF-Token'] = csrfToken;
  }

  return fetch(url, {
    credentials: 'include',
    ...options,
    headers,
  });
}

export function apiGet(path: string) {
  return api(path, { method: 'GET' });
}

export function apiPost(path: string, body?: unknown) {
  return api(path, {
    method: 'POST',
    body: body ? JSON.stringify(body) : undefined,
  });
}

export function apiPut(path: string, body?: unknown) {
  return api(path, {
    method: 'PUT',
    body: body ? JSON.stringify(body) : undefined,
  });
}

export function apiPatch(path: string, body?: unknown) {
  return api(path, {
    method: 'PATCH',
    body: body ? JSON.stringify(body) : undefined,
  });
}

export function apiDelete(path: string) {
  return api(path, { method: 'DELETE' });
}
